import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';
import { textsData } from 'constants/conditions';

export const conditionsAnimation = () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `#${SECTIONS_IDS.conditions}`,
      end: '+=1200',
      scrub: true,
      pin: true,
      pinSpacing: 'padding',
      invalidateOnRefresh: true,
    },
  });

  textsData.forEach((_, i) => {
    if (i === 0) {
      tl.to(`#${SECTIONS_IDS.conditions}-text-block-${i + 1}`, { yPercent: -20, opacity: 0 });
    } else {
      tl.fromTo(
        `#${SECTIONS_IDS.conditions}-text-block-${i + 1}`,
        { yPercent: 20, opacity: 0 },
        { yPercent: 0, opacity: 1 },
      );
      textsData.length !== i + 1 &&
        tl.to(`#${SECTIONS_IDS.conditions}-text-block-${i + 1}`, { yPercent: -20, opacity: 0 });
    }
  });
};
